export default __webpack_public_path__ + "static/media/mail-box.0e9fdb44.svg";